module.exports = __webpack_public_path__ + "static/DTT_Icone_Courriel-1dbbcddd6210ffc8c24bbe768ac0057b.svg";